import { Injectable } from '@angular/core';
import { Widget } from './Widget';

@Injectable()
export class WidgetInjectedData {
    widgetRef: Widget;
}
